var _path, _ellipse, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRulo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.105 6.058c.19-.749.523-1.542 1.057-2.386l.444-.742a1.9 1.9 0 00.194-1.52C24.493.374 23.38-.223 22.316.076l-.305.088c-6.446 1.933-13.16 7.902-17.154 13.54C1.822 17.324 0 21.954 0 27c0 11.598 9.626 21 21.5 21S43 38.598 43 27c0-11.07-8.77-20.14-19.895-20.942z",
    fill: "#5373E9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 27,
    rx: 14,
    ry: 7,
    fill: "#F0F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.177 26A2.177 2.177 0 0018 28.177v1.646a2.177 2.177 0 004.355 0v-1.646A2.177 2.177 0 0020.177 26zm10.646 0a2.177 2.177 0 00-2.178 2.177v1.646a2.177 2.177 0 104.355 0v-1.646A2.177 2.177 0 0030.823 26z",
    fill: "#37C2CF"
  })));
}

export default SvgRulo;